"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const TollRateCalculator_1 = require("./TollRateCalculator");
if (document.getElementById('toll-rate-calculator-wrapper')) {
    react_dom_1.default.render(react_1.default.createElement(TollRateCalculator_1.TollRateCalculator, null), document.getElementById('toll-rate-calculator-wrapper'));
}
